
class Utils {
    static randomString(length) {
        const chars = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
        var result = '';
        for (var i = length; i > 0; --i) result += chars[Math.floor(Math.random() * chars.length)];
        return result;
    }

    static getTimeNowAsString() {
        var da = new Date();
        var daDate = da.getFullYear() + "-" + (da.getMonth() + 1) + "-" + da.getDate() + "_";
        var daTime = da.getHours() + "_" + da.getMinutes() + "_" + da.getSeconds() + "_" + da.getMilliseconds();
        return daDate + "-" + daTime;
    }

    static getTimeStampAsString(timestamp) {
        var da = new Date(timestamp);
        var daDate = da.getFullYear() + "-" + (da.getMonth() + 1) + "-" + da.getDate() + "_";
        var daTime = da.getHours() + "_" + da.getMinutes() + "_" + da.getSeconds() + "_" + da.getMilliseconds();
        return daDate + "-" + daTime;
    }


    static getDateAsISOString(timestamp) {
        // Returns in format YYYY-MM-DD
        var da = new Date(timestamp);
        var daDate = da.getFullYear() + "-" + (da.getMonth() + 1) + "-" + da.getDate();
        return daDate;
    }


    static adjustDate(date, type) {
      
        let result = date;
        console.log("Hours:", date.getHours())
        console.log("      ", date.getMinutes())
        console.log("      ", date.getSeconds())
        if (type === "end") {
            result.setHours(22);
            result.setMinutes(58);
            result.setSeconds(58); 
            console.log("Hours end:", result.getHours())
            console.log("      ", result.getMinutes())
            console.log("      ", result.getSeconds())
        }

  

        if (type === "start") {
            result.setHours(0);
            result.setMinutes(0);
            result.setSeconds(0);  
            console.log("Hours start:", result.getHours())
            console.log("      ", result.getMinutes())
            console.log("      ", result.getSeconds())

        }

  
        return result;
               
    }

    static getGermanDate(date) {

        if (!date) {
            return "-";   
        }

        let year;
        year = date.getUTCFullYear();

        let month = date.getUTCMonth() + 1;
        if (month < 10 ) month = "0"+month

        let day = date.getUTCDate() 
        if (day < 10) day = "0" + day

        let hour = date.getUTCHours()
        if (hour < 10) hour = "0" + hour

        let minute = date.getUTCMinutes()
        if (minute < 10) minute = "0" + minute

        return day + "." + month + "." + year + ",    " + hour + ":" + minute;
    }

}

export { Utils };
